import { createFileRoute, Outlet, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth-context";
import { modCanDept, type ModeratorPermissions } from "@/lib/moderator-permissions";

export const Route = createFileRoute("/_app/_hr")({
  component: HrLayout,
});

function HrLayout() {
  const { role, profile, loading } = useAuth();
  if (loading) return null;
  if (role === "admin") return <Outlet />;
  if (profile?.department === "hr") return <Outlet />;
  const perms = (profile?.moderator_permissions ?? {}) as ModeratorPermissions;
  if (role === "moderator" && modCanDept(perms, "hr", "view")) return <Outlet />;
  return <Navigate to="/dashboard" />;
}
